(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setControlState = (wrapper, video, control) => {
    const isPaused = video.paused;
    const pauseIcon = control?.querySelector('[data-video-pause-icon]');
    const playIcon = control?.querySelector('[data-video-play-icon]');

    wrapper.classList.toggle('is-paused', isPaused);

    if (!control) return;

    control.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');
    if (pauseIcon) pauseIcon.hidden = isPaused;
    if (playIcon) playIcon.hidden = !isPaused;
  };

  const initializeVideo = (wrapper) => {
    if (wrapper.dataset.heroVideoInitialized === 'true') return;

    const video = wrapper.querySelector('video');
    const control = wrapper.querySelector('[data-hero-video-control]');
    if (!video) return;

    wrapper.dataset.heroVideoInitialized = 'true';

    const applyMotionPreference = () => {
      if (reducedMotion.matches) {
        video.pause();
        wrapper.classList.add('is-reduced-motion');
      } else if (wrapper.classList.contains('is-reduced-motion')) {
        wrapper.classList.remove('is-reduced-motion');
        video.play().catch(() => setControlState(wrapper, video, control));
      }

      setControlState(wrapper, video, control);
    };

    control?.addEventListener('click', () => {
      if (video.paused) {
        wrapper.classList.remove('is-reduced-motion');
        video.play().catch(() => setControlState(wrapper, video, control));
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => setControlState(wrapper, video, control));
    video.addEventListener('pause', () => setControlState(wrapper, video, control));
    applyMotionPreference();

    reducedMotion.addEventListener?.('change', applyMotionPreference);
  };

  const initializeVideos = (root = document) => {
    root.querySelectorAll('[data-hero-video-wrapper]').forEach(initializeVideo);
  };

  initializeVideos();
  document.addEventListener('shopify:section:load', (event) => initializeVideos(event.target));
})();
